export class GraphPair {
    x: number;
    y: number;
}
